import { render } from "./App.vue?vue&type=template&id=39855f36&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=39855f36&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/front_prod/dark_guide/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39855f36"]])

export default __exports__